var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.941 18.9819H1C0.447715 18.9819 0 19.4296 0 19.9819C0 20.5342 0.447715 20.9819 1 20.9819H22.941C23.4933 20.9819 23.941 20.5342 23.941 19.9819C23.941 19.4296 23.4933 18.9819 22.941 18.9819Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.031 15.1411C13.7007 16.51 11.9115 17.3391 10.007 17.469C7.80269 17.6167 5.63585 16.8438 4.02234 15.3347C2.40884 13.8257 1.49304 11.7153 1.493 9.5061V4.01807C1.493 3.46582 1.9407 3.01807 2.493 3.01807H16.454C17.0063 3.01807 17.454 3.46582 17.454 4.01807V4.51807C17.454 4.79419 17.6779 5.01807 17.954 5.01807H19.013C21.7672 5.01807 24 7.25073 24 10.0051C24 12.7593 21.7672 14.9922 19.013 14.9922H15.386C15.2525 14.9924 15.1247 15.0459 15.031 15.1411ZM22.005 10.0049C22.005 8.35254 20.6654 7.01294 19.013 7.01294L17.955 7.01099C17.6788 7.01099 17.455 7.23486 17.455 7.51099V9.23291C17.4549 10.2883 17.2564 11.334 16.87 12.3159C16.8104 12.4695 16.8302 12.6426 16.9229 12.7786C17.0156 12.9146 17.1693 12.9963 17.334 12.9971H19.013C20.6654 12.9971 22.005 11.6575 22.005 10.0049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.5dbd90fa.svg";
export { ForwardRef as ReactComponent };